import { createSlice } from '@reduxjs/toolkit'

import { expireSession } from '../auth/actions'
import {
  pushErrorNotification,
  pushFeedbackNotification,
  pushProgressNotification,
  pushSuccessNotification,
} from './actions'
import { pushNotificationReducer, removeNotificationReducer } from './reducers'
import { type NotificationsSlice } from './types'

const initialState: NotificationsSlice = {
  notifications: [],
}

const notificationsSlice = createSlice({
  name: 'notification',
  initialState,
  reducers: {
    pushNotification: pushNotificationReducer,
    removeNotification: removeNotificationReducer,
  },
  extraReducers: (builder) =>
    builder
      .addCase(pushSuccessNotification, pushNotificationReducer)
      .addCase(pushErrorNotification, pushNotificationReducer)
      .addCase(pushProgressNotification, pushNotificationReducer)
      .addCase(pushFeedbackNotification, pushNotificationReducer)
      .addCase(expireSession, () => initialState),
})

export default notificationsSlice.reducer

export const { removeNotification } = notificationsSlice.actions
